module.exports = __webpack_public_path__ + "img/04.01c32f60.png";